// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/usage/v1/rate.proto (package chalk.usage.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/usage/v1/rate.proto.
 */
export const file_chalk_usage_v1_rate: GenFile = /*@__PURE__*/
  fileDesc("ChljaGFsay91c2FnZS92MS9yYXRlLnByb3RvEg5jaGFsay51c2FnZS52MSK/AQoLTWFjaGluZVJhdGUSFAoMbWFjaGluZV90eXBlGAEgASgJEgwKBGNwdXMYAiABKAESEQoJbWVtb3J5X2diGAMgASgBEhgKEGNyZWRpdHNfcGVyX2hvdXIYBCABKAESKwoFY2xvdWQYBSABKA4yHC5jaGFsay51c2FnZS52MS5CaWxsaW5nQ2xvdWQSFgoObWFjaGluZV9mYW1pbHkYBiABKAkSEQoEZ3B1cxgHIAEoAUgAiAEBQgcKBV9ncHVzIpUCChFDbG91ZEluc3RhbmNlVHlwZRIUCgxtYWNoaW5lX3R5cGUYASABKAkSDAoEY3B1cxgCIAEoARIRCgltZW1vcnlfZ2IYAyABKAESKwoFY2xvdWQYBCABKA4yHC5jaGFsay51c2FnZS52MS5CaWxsaW5nQ2xvdWQSFgoObWFjaGluZV9mYW1pbHkYBSABKAkSEQoEZ3B1cxgGIAEoAUgAiAEBEhcKD2xvY2FsX3NzZF9jb3VudBgHIAEoBRIZChFsb2NhbF9zc2Rfc2l6ZV9nYhgIIAEoBRIaChJna2VfYm9vdF9kaXNrX3R5cGUYCSABKAkSGAoQb2xkZXJfZ2VuZXJhdGlvbhgKIAEoCEIHCgVfZ3B1cyp0CgxCaWxsaW5nQ2xvdWQSHQoZQklMTElOR19DTE9VRF9VTlNQRUNJRklFRBAAEhUKEUJJTExJTkdfQ0xPVURfQVdTEAESFQoRQklMTElOR19DTE9VRF9HQ1AQAhIXChNCSUxMSU5HX0NMT1VEX0FaVVJFEANCEloQdXNhZ2UvdjE7dXNhZ2V2MWIGcHJvdG8z");

/**
 * @generated from message chalk.usage.v1.MachineRate
 */
export type MachineRate = Message<"chalk.usage.v1.MachineRate"> & {
  /**
   * @generated from field: string machine_type = 1;
   */
  machineType: string;

  /**
   * @generated from field: double cpus = 2;
   */
  cpus: number;

  /**
   * @generated from field: double memory_gb = 3;
   */
  memoryGb: number;

  /**
   * @generated from field: double credits_per_hour = 4;
   */
  creditsPerHour: number;

  /**
   * @generated from field: chalk.usage.v1.BillingCloud cloud = 5;
   */
  cloud: BillingCloud;

  /**
   * @generated from field: string machine_family = 6;
   */
  machineFamily: string;

  /**
   * @generated from field: optional double gpus = 7;
   */
  gpus?: number;
};

/**
 * Describes the message chalk.usage.v1.MachineRate.
 * Use `create(MachineRateSchema)` to create a new message.
 */
export const MachineRateSchema: GenMessage<MachineRate> = /*@__PURE__*/
  messageDesc(file_chalk_usage_v1_rate, 0);

/**
 * @generated from message chalk.usage.v1.CloudInstanceType
 */
export type CloudInstanceType = Message<"chalk.usage.v1.CloudInstanceType"> & {
  /**
   * @generated from field: string machine_type = 1;
   */
  machineType: string;

  /**
   * @generated from field: double cpus = 2;
   */
  cpus: number;

  /**
   * @generated from field: double memory_gb = 3;
   */
  memoryGb: number;

  /**
   * @generated from field: chalk.usage.v1.BillingCloud cloud = 4;
   */
  cloud: BillingCloud;

  /**
   * @generated from field: string machine_family = 5;
   */
  machineFamily: string;

  /**
   * @generated from field: optional double gpus = 6;
   */
  gpus?: number;

  /**
   * @generated from field: int32 local_ssd_count = 7;
   */
  localSsdCount: number;

  /**
   * @generated from field: int32 local_ssd_size_gb = 8;
   */
  localSsdSizeGb: number;

  /**
   * Boot disk type required when GKE auto-provisions nodes of this machine type
   * (e.g. "hyperdisk-balanced" for c4d, which supports no Persistent Disk flavor).
   * Set only for GCP instance types that back Chalk machine type mappings; empty
   * means "inherit the cluster's node auto-provisioning default disk type".
   *
   * @generated from field: string gke_boot_disk_type = 9;
   */
  gkeBootDiskType: string;

  /**
   * Whether this instance type belongs to an older generation that can have reduced performance.
   *
   * @generated from field: bool older_generation = 10;
   */
  olderGeneration: boolean;
};

/**
 * Describes the message chalk.usage.v1.CloudInstanceType.
 * Use `create(CloudInstanceTypeSchema)` to create a new message.
 */
export const CloudInstanceTypeSchema: GenMessage<CloudInstanceType> = /*@__PURE__*/
  messageDesc(file_chalk_usage_v1_rate, 1);

/**
 * Cloud represents a cloud provider.
 *
 * @generated from enum chalk.usage.v1.BillingCloud
 */
export enum BillingCloud {
  /**
   * @generated from enum value: BILLING_CLOUD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_CLOUD_AWS = 1;
   */
  AWS = 1,

  /**
   * @generated from enum value: BILLING_CLOUD_GCP = 2;
   */
  GCP = 2,

  /**
   * @generated from enum value: BILLING_CLOUD_AZURE = 3;
   */
  AZURE = 3,
}

/**
 * Describes the enum chalk.usage.v1.BillingCloud.
 */
export const BillingCloudSchema: GenEnum<BillingCloud> = /*@__PURE__*/
  enumDesc(file_chalk_usage_v1_rate, 0);

